<template>
    <div class="home-auditor">
        <heading :title="'Auditor Dashboard'" tag="home-auditor-title"/>
        <b-row>
            <div class="col-sm-6">
                <notification-list-widget/>
            </div>
            <div class="col-sm-6">
                <message-list-widget/>
            </div>
        </b-row>
        <b-row>
            <div class="col-sm-12">
                <project-list-widget
                    :title="'Projects Assigned as Auditor'"
                    :show-exemptions="true"/>
            </div>
        </b-row>
    </div>
</template>

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'HomeAuditor',
})
</script>
